// Leads API client.
//
// Aufgabe 11 (06.10.2026) — two paths:
//   * `createLead`        — legacy, authenticated users only.
//   * `startPublicLead` + `createPublicLead` — guest-capable. The start
//     call hands out a one-shot token that carries the server-side
//     submit-time window; without it the request is rejected.
import { apiClient } from "./client";

export async function createLead(payload) {
  const r = await apiClient.post("/leads", payload);
  return r.data;
}

export async function startPublicLead() {
  const r = await apiClient.post("/leads/public/start");
  return r.data;
}

export async function createPublicLead(payload) {
  const r = await apiClient.post("/leads/public", payload);
  return r.data;
}
